import Vue from 'vue'
import Component from 'vue-class-component'
import {UtilService, loadsearchData} from '../models/UtilService';
import {ProductVersion, Language, Product, ViewPortModus} from '../models/ProductModels';
import {Viewport} from '../models/Viewport';
 

@Component({
  name:'search-component',
  props: {
    viewport:{

    },
    searchlink:{

    }
  }
})
export default class SearchComponent extends Vue {

  viewport:Viewport;
  searchlink:string;
  allProdVersions:ProductVersion[]=[];
  searchTerm:string='';
  foundTerms:ProductVersion[]=[];
  isOpen:boolean=false; 
  placeholder:string='';


  public getPlaceholder(){
    if(this.viewport.viewportModus === ViewPortModus.STARTPAGE)
    {
      this.placeholder = this.viewport.viewportLanguage==Language.DE?'Suche nach Produkt...':'Search for Product...';
    }
    else if(this.viewport.viewportModus === ViewPortModus.PRODUCT_SECTION){
      this.placeholder = this.viewport.viewportLanguage==Language.DE?'Begriffsuche in Manualen...':'Search for term in Manuals...';
    }
  }

  computeIsOpen():boolean{
    return false;
  }

  matchingProducts(searchTerm:string):Product[]{
    
    return <Product[]>Object.values(this.viewport.utilserv.productStructur.products).filter((term)=>{
      return (<Product>term).name.toLowerCase().indexOf(this.searchTerm.toLocaleLowerCase()) >=0;
    })
  }

  setProdName(products:Product[]):Product[]{
    for(let prod of products){
      prod.versions.forEach((prodVersion) =>{
        prodVersion.productName = prod.name;
      });
    }
    return products;
  }

  mouseDownOnDropDown(event){
   // console.log('CLICK HAPPENED');
    
    return false;
  }

  matchingProductVersions():void{
    loadsearchData(this.searchTerm,Language[this.viewport.viewportLanguage])
    .done(response => {
     // console.log('Gone well fetching searchData for..',this.searchTerm);
      //console.dir(response);
     // this.foundTerms = response.foundProducts;
      this.foundTerms = response.foundManuals;
    })
    .fail(xhr => {
      throw new Error('An error occured while getting searchResults for searchTerm:'+this.searchTerm+"  " + xhr);
    })
    .catch(xhr => {
        console.log(xhr);
        throw new Error('Error initializing Index-Viewport: ' + xhr);
    });
  }

  get filteredTerms():ProductVersion[]{

    let matchProducts:Product[] = this.matchingProducts(this.searchTerm);

    matchProducts = this.setProdName(matchProducts);
   
    //console.log('MATCHING- PRODUCTS  ',matchProducts );

    let result:ProductVersion[] = [];

    for(let singleProd of matchProducts){
     result = result.concat(singleProd.versions);
    }

    //console.log('MATCHING PRODVERSIONS ', result);

    return result;
  } 

  cleanSearchTerm():string{
   // return this.searchTerm.replace(/\\/g, '');
   //console.log('ENTERING SEARCH-TERM');
    //return encodeURI(this.searchTerm);
    //console.log('LEAVING SEARCH-TERM');
    return this.searchTerm;
 }

  loadSearchTerm(){
    if(this.searchTerm.length<3)
    {
      return;
    }
    this.isOpen=true;
    this.matchingProductVersions();
    //this.foundTerms = this.filteredTerms;
    //console.log('Searching Term ',this.searchTerm);
    //console.log('FoundTerms-Length ',this.foundTerms.length);
  }


  selectProdVers(term:ProductVersion){
    this.searchTerm = term.version;
    window.location.href = this.getUrl(term);   
  }

  created(){

    //Compute Versions
    this.getPlaceholder();
    let versionsArray:{name:string, spaceKey:string}[] = [];
/*
    for (let prod in this.viewport.utilserv.productStructur.products){

    }
    */
  }

  getUrl(prodVersion:ProductVersion):string{
    return prodVersion.spaceUrl;// process.env.VUE_APP_BASE_URL+'/'+prodVersion.spaceKey;
  }

  gotoSearchPage(){
//let newHRef:string = this.searchlink+'?q='+this.searchTerm+'&s=*'+(Language[this.viewport.viewportLanguage]).toLowerCase();
let newHRef:string = this.searchlink+'?q='+this.cleanSearchTerm()+'';
newHRef+="&t=attachment,page,blog_post";
 window.location.href = encodeURI(newHRef);  
}
}
